<template>
  <div class="grafana-dashboard">
    <iframe :src="grafanaUrl" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: "GrafanaDashboard",
  data() {
    return {
      // La URL incluye el parámetro kiosk=tv para iniciar en modo kiosk
      grafanaUrl:
        "https://grafana.axia-monitoring.com/d/feh3voza6s3r4a/dashboard-axia-monitoring?orgId=1&from=now-6h&to=now&timezone=browser&var-MACserie=sBle000010&theme=light&kiosk",
    };
  },
};
</script>

<style scoped>
/* Ajusta el contenedor para que ocupe el alto total de la ventana menos la altura de la navbar */
.grafana-dashboard {
  height: calc(
    100vh - 60px
  ); /* Ajusta "60px" según la altura real de tu navbar */
  width: 100%;
  overflow: hidden;
}

/* El iframe ocupará el 100% del contenedor */
.grafana-dashboard iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
